import React, { useEffect, useState } from "react";
import "./LaunchModal.css";
import { setSideMenuBarOpen } from "../../appState/slices/auth/authSlice";
import { useDispatch } from "react-redux";

const LAUNCH_START = new Date("2026-10-11T10:15:00+05:30");

// Launch pricing ends 48 hours after launch
const LAUNCH_END = new Date(
    LAUNCH_START.getTime() + 96 * 60 * 60 * 1000
);

const LaunchModal = ({ onClose }) => {

    const calculateTimeLeft = () => {
        const now = new Date();

        const difference = LAUNCH_END.getTime() - now.getTime();

        if (difference <= 0) {
            return {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            };
        }

        return {
            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
            hours: Math.floor(
                (difference / (1000 * 60 * 60)) % 24
            ),
            minutes: Math.floor(
                (difference / (1000 * 60)) % 60
            ),
            seconds: Math.floor(
                (difference / 1000) % 60
            )
        };
    };

    const [timeLeft, setTimeLeft] = useState(
        calculateTimeLeft()
    );
    const dispatch = useDispatch();

    useEffect(() => {

        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);

    }, []);

    const formatNumber = (number) => {
        return String(number).padStart(2, "0");
    };

    const handleShopClick = async() => {
       await  dispatch(setSideMenuBarOpen(true))
        onClose();

        // Change this route if your product listing route is different
        // window.location.href = "/products";
    };

    return (
        <div className="launch-modal-overlay">

            <div className="launch-modal">

                {/* Close button */}
                <button
                    className="launch-modal-close"
                    onClick={onClose}
                    aria-label="Close"
                >
                    ×
                </button>

                {/* Left image section */}
                <div className="launch-modal-image">

                    <div className="launch-image-overlay">

                        <div className="launch-image-text">
                            <span>PURECARATS</span>

                            <p>
                                Timeless diamonds.
                                <br />
                                Modern luxury.
                            </p>
                        </div>

                    </div>

                </div>

                {/* Right content */}
                <div className="launch-modal-content">

                    {/* <div className="launch-brand">
                        PURECARATS
                    </div> */}

                    {/* <div className="launch-divider"></div> */}

                    <div className="launch-eyebrow">
                        WE'RE FINALLY LIVE
                    </div>

                    <h1>
                        Launch Prices
                        <br />
                        Are Here
                    </h1>

                    <p className="launch-description">
                        We've dropped our prices specially
                        for our launch.
                    </p>

                    <div className="launch-highlight">
                        Enjoy our lowest prices for the next
                        48 hours.
                    </div>

                    <p className="launch-after-text">
                        After that, prices go back up.
                    </p>

                    {/* Countdown */}
                    <div className="launch-countdown">

                        <div className="countdown-item">
                            <span>
                                {formatNumber(timeLeft.days)}
                            </span>
                            <small>DAYS</small>
                        </div>

                        <div className="countdown-divider"></div>

                        <div className="countdown-item">
                            <span>
                                {formatNumber(timeLeft.hours)}
                            </span>
                            <small>HOURS</small>
                        </div>

                        <div className="countdown-divider"></div>

                        <div className="countdown-item">
                            <span>
                                {formatNumber(timeLeft.minutes)}
                            </span>
                            <small>MINUTES</small>
                        </div>

                        <div className="countdown-divider"></div>

                        <div className="countdown-item">
                            <span>
                                {formatNumber(timeLeft.seconds)}
                            </span>
                            <small>SECONDS</small>
                        </div>

                    </div>

                    {/* CTA */}
                    <button
                        className="launch-shop-button"
                        onClick={handleShopClick}
                    >
                        SHOP THE LAUNCH
                        <span>→</span>
                    </button>

                    <p className="launch-disclaimer">
                        Launch pricing valid for 48 hours from launch.
                    </p>

                </div>

            </div>

        </div>
    );
};

export default LaunchModal;